<div class="h-100">
  <app-color-switcher *ngIf="isMultiColorActive"></app-color-switcher>
  <router-outlet></router-outlet>
  <simple-notifications></simple-notifications>
</div>



